<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<div class="flex">
					<div style="margin-right: 10px;width: 100px;">采购等级</div>
					<el-checkbox-group v-model="recommendlevel" @change="recommendlevelChange">
						<el-checkbox label="S"></el-checkbox>
						<el-checkbox label="A"></el-checkbox>
						<el-checkbox label="B"></el-checkbox>
						<el-checkbox label="C"></el-checkbox>
						<el-checkbox label="D"></el-checkbox>
						<el-checkbox label="新品"></el-checkbox>
					</el-checkbox-group>
				</div>
				<div class="flex" v-if="policytype!=0">
					<div style="margin-right: 10px;width: 100px;">未采购</div>
					<el-checkbox-group v-model="unpurchase" @change="unpurchaseChange">
						<el-checkbox :label="1" >是</el-checkbox>
					</el-checkbox-group>
				</div>
				<div class="flex" v-if="policytype==0">
					<div style="margin-right: 10px;width: 100px;">是否达到预警线</div>
					<el-checkbox-group v-model="warningline" @change="warninglineChange">
						<el-checkbox :label="1" >是</el-checkbox>
					</el-checkbox-group>
				</div>
				<vxe-grid ref="stockwarningstaticList" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<hitchhiking-form ref="hitchhikingForm" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="生成采购单" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	// const formjson = {
	// 	title: '表单',
	// 	rule: {
	// 		"width": "800",
	// 		"height": "600",
	// 		"fApi": [],
	// 		"rule": [
	// 			{
	// 				"type": "$input",
	// 				"field": "input",
	// 				"title": "input",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {
	// 					"readonly":true
	// 				},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$datePicker",
	// 				"field": "time",
	// 				"title": "time",
	// 				"props": {
	// 					"type": "date",
	// 					"disabled":true
	// 				},
	// 				"value": null,
	// 				"hidden": false,
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$emun",
	// 				"field": "emun",
	// 				"title": "emun",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {
	// 					"name": "enable"
	// 				},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$upload",
	// 				"field": "upload",
	// 				"title": "upload",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			}
	// 		],
	// 		"option": {
	// 			"form": {
	// 				"labelWidth": "80px",
	// 				"hideRequiredAsterisk": false,
	// 				"showMessage": false,
	// 				"inlineMessage": false
	// 			},
	// 			"global": {
	// 				"*": {
	// 					"props": {
	// 						"el": true,
	// 						"size": "small",
	// 						"disabled": false
	// 					},
	// 					"col": {
	// 						"span": 24,
	// 						"offset": 0
	// 					}
	// 				},
	// 				"el-divider": {
	// 					"wrap": {
	// 						"show": false
	// 					},
	// 					"native": false,
	// 					"col": {
	// 						"span": 24,
	// 						"offset": 0
	// 					},
	// 					"props": {
	// 						"contentPosition": "left"
	// 					}
	// 				}
	// 			},
	// 			"submitBtn": false,
	// 			"resetBtn": false
	// 		}
	// 	}
	// }
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import hitchhikingForm from './hitchhiking.vue'

	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			policytype: {
				default: () => {
					return 311
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '统计',
				modal_width: 800,
				modal_height: 600,
				recommendlevel:['S','A'],
				unpurchase:[1],
				warningline:[],
				list_footerField: [{
						field: 'count',
						toFixed: 0
					},{
						field: 'quantity',
						toFixed: 0
					},
					{
						field: 'sum',
						toFixed: 2
					}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.recommendlevel = ['S','A']
				if(this.policytype == 0){
					this.unpurchase = []
					this.warningline = [1]
				}else{
					this.unpurchase = [1]
					this.warningline = []
				}
				this.$nextTick(()=>{
					let statics = this.statics()
					this.$refs.stockwarningstaticList.reloadData(statics)
				})
				this.$emit('show')
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 450
				gridOptions.proxyConfig.autoLoad = false
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [],
					customConfig: {
						storage: true
					},
					custom: false,
					refresh: false,
					zoom: false,
					tools: []
				}
				// gridOptions.toolbarConfig = {
				// 	size: 'mini',
				// 	perfect: false,
				// 	buttons: [{
				// 		name: '搭车采购',
				// 		status: 'primary',
				// 		code: 'hitchhiking'
				// 	}],
				// 	customConfig: {
				// 		storage: true
				// 	},
				// 	custom: true,
				// 	refresh: true,
				// 	zoom: true,
				// 	tools: []
				// }
				gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width: 50
					}, {
						field: 'supplierID',
						title: '供应商ID',
						visible: false
					}, {
						field: 'supplierName',
						title: '供应商',
					}, {
						field: 'count',
						title: '件数',
						sortable: true
					}, {
						field: 'quantity',
						title: '数量',
						sortable: true
					}, 
					// {
					// 	field: 'hasemergent',
					// 	title: '存在应急',
					// 	sortable: true
					// }, 
					{
						field: 'sum',
						title: '金额',
						sortable: true
					},
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
					// 		}
					// 	}
					// }
				]
				gridOptions.formConfig = false
				// gridOptions.editRules = {
				// 	c: [{
				// 		required: true
				// 	},{
				// 		validator({cellValue,row}){
				// 			return new Promise((resolve,reject)=>{
				// 				if( true ){
				// 					reject(new Error('自定义错误'))
				// 				}else{
				// 					resolve()
				// 				}

				// 			})
				// 		}
				// 	}]
				// }
			},
			recommendlevelChange(){
				let statics = this.statics()
				this.$refs.stockwarningstaticList.reloadData(statics)
			},
			warninglineChange(){
				let statics = this.statics()
				this.$refs.stockwarningstaticList.reloadData(statics)
			},
			unpurchaseChange(){
				let statics = this.statics()
				this.$refs.stockwarningstaticList.reloadData(statics)
			},
			list(){
				// let statics = this.statics()
				// return new Promise((resolve) => {
				// 	resolve({
				// 		list: statics
				// 	})
				// })
			},
			statics(){
				let data = this.data
				if(this.recommendlevel.length){
					data = data.filter((item)=>{
						return this.recommendlevel.findIndex((_item)=>{
							return _item == item.recommendlevel
						})!==-1
					})
				}
				if(this.unpurchase.length){
					data = data.filter((item)=>{
						return !item.billCode
					})
				}
				
				
				if(this.warningline.length){
					data = data.filter((item)=>{						
						return this.warningline.findIndex((_item)=>{
							return _item == item.warningline
						})!==-1
					})
				}

				let statics = this.$Lodash(data).groupBy('supplierid').map((group, key) => ({
					id: key,
					supplierID: key,
					supplierName: group[0].suppliername,
					count: group.length,
					quantity: this.$Lodash.sumBy(group, 'purchasenum'),
					hasemergent: group.some((item) => {
						return item.policytype == 312
					}) ? '是' : '否',
					sum: this.$Lodash.sumBy(group, (item) => {
						return item.taxprice * item.purchasenum
					}).toFixed(2)
				})).value()
				
				return statics
			},

			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			setFormData() {
				if (this.sourceData) {
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid() {
				return this.$refs.list
			},
			add() {
				this.getgrid().insert({})
			},
			delete(row) {
				this.getgrid().remove(row)
			},
			submit() {
				let data = this.$refs.stockwarningstaticList.getCheckboxRecords()
				if (!data.length) {
					this.$message.error('请选择供应商')
					return
				}
				if(data.length > 20){
					this.$message.error('供应商一次不能超过20个')
					return
				}
				this.$emit('submit', {
					data:data,
					recommendlevel:this.recommendlevel,
				})
				this.modal_cancel()
			},
			createDetail(data) {
				data = JSON.parse(JSON.stringify(data))
				data.forEach((item) => {
					delete(item['_X_ROW_CHILD'])
					delete(item['_X_ROW_KEY'])
				})
				return data
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k] / 1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i] / 1000
					}
				}
			},
			reset() {
				//this.init()
			},
			list_sum(field, data, toFixed) {
				let sum = 0
				if (this.statisticsfield) {
					if (this.sourcestatisticsdata[field]) {
						sum = this.sourcestatisticsdata[field]
					}
					return sum
				} else {
					data.forEach((item) => {
						for (let i in item) {
							if (i == field) {
								sum = sum + (isNaN(parseFloat(item[i])) ? 0 : parseFloat(item[i]))
							}
						}
					})
					return sum.toFixed(toFixed)
				}

			},
		},
		components: {
			hitchhikingForm
		}
	}
</script>